import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { MyReviewList } from '@/widgets/my-review-list';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 마이페이지 내 후기(/my/reviews) — 내 주문 목록과 같은 틀(큰 머리 아래 왼쪽 메뉴와 목록). */
export const MyReviewsPage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <MyPageHeader />
    <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
      <MyPageNav activeId="reviews" />
      <section aria-labelledby="my-reviews-heading" className="flex min-w-0 flex-col gap-6">
        <h2
          id="my-reviews-heading"
          className="text-2xl leading-tight font-bold tracking-[-0.02em] sm:text-[1.75rem]"
        >
          내 후기
        </h2>
        <MyReviewList />
      </section>
    </div>
  </SitePageShell>
);
